import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/rawMaterialSupplier',
    meta: { title: '原料供应商' },
    component: Layout,
    redirect: '/rawMaterialSupplier/list',
    children: [
      {
        path: 'list',
        meta: { title: '原料供应商', activeMenu: '/rawMaterialSupplier' },
        component: () => import('@/views/rawMaterialSupplier/RawMaterialSupplier.vue')
      },
      {
        path: 'detail',
        meta: { title: '原料供应商详情', activeMenu: '/rawMaterialSupplier' },
        component: () => import('@/views/rawMaterialSupplier/RawMaterialSupplierDetail.vue')
      },
      {
        path: 'add',
        meta: { title: '新增原料供应商', activeMenu: '/rawMaterialSupplier' },
        component: () => import('@/views/rawMaterialSupplier/RawMaterialSupplierAdd.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑原料供应商', activeMenu: '/rawMaterialSupplier' },
        component: () => import('@/views/rawMaterialSupplier/RawMaterialSupplierAdd.vue')
      }

    ]
  }

]
